module.exports = __webpack_public_path__ + "img/paishui (4).a3b30809.png";